import React from 'react';
import SkeletonFeedCard from './SkeletonFeedCard';
import SkeletonCommunityCard from './SkeletonCommunityCard';

function SkeletonListFeed({ count = 3, cardType = 'feed' }) {
  const Card = cardType === 'community' ? SkeletonCommunityCard : SkeletonFeedCard;

  return (
    <div className="box-col pd0 gap10">
      {Array.from({ length: count }).map((_, i) => (
        <Card key={i} />
      ))}
    </div>
  );
}

export default SkeletonListFeed;
